// Requests
import PostCall from "./CommonApi";

export default function GetSubmitPayment(
  paymentToken,
  usasCodes,
  outTransactionId,
  traceNumber,
  uuid,
  ipAddress,
  nameOnCard,
  cardType,
  cvv,
  lastFourDigitsCard,
  cardExpiration,
  streetAddress,
  streetAddress2, 
  city,
  state,
  zip,
  usasLines
) {
  let url = "/v1/ovra/transaction/v5/SubmitPayment";
  let requestObject = 
      {
        applicationId: "OVRA",
        agencyId: "DSHS",
        transactionStatus: "EPAY",
        outTransactionId: outTransactionId,
        uniqueIdentifier: uuid,
        paymentToken: paymentToken,
        traceNumber: traceNumber,
        agencyCode: "537",
        paymentMode: "CC",
        ipAddress: ipAddress,
        paymentMethod: {
          nameOnCard: nameOnCard,
          cardType: cardType,
          cvv: cvv,
          lastFourDigitsCard: lastFourDigitsCard,
          cardExpiration: cardExpiration,
          billingAddress: {
            address1: streetAddress,
            address2: streetAddress2,
            city: city,
            state: state,
            postalCode: zip
          }
	},
        paymentInfo: [
          {
            type: "PAYMENT",
            description: "OVRA-Vital Statistics Unit",
            paymentAmount: JSON.parse(sessionStorage.getItem("paymentItem"))
              .totalAmount,
            convenienceFee: JSON.parse(sessionStorage.getItem("paymentItem"))
              .convenienceFee,  
            quantity: 1,
            sku: "0045078537VS",
            usasLines: usasLines,
            usasCodes: usasCodes,
          },
        ],
        additionalInfo: [
          {
            key: "SourceApplication",
            value: "OVRA",
          },
          {
            key: "hostname",
            value: ipAddress,
          },
        ],
      }
    return PostCall(url, requestObject);
}
